module.exports = __webpack_public_path__ + "img/add-icon-grey.53e34acb.svg";